if (document.getElementById("vue-document")) {
    new Vue({
        delimiters: ["[[", "]]"],
        el: '#vue-document',
        propsData: { ...document.getElementById("vue-document").dataset },
        props: {
            articleid: {
                type: String,
                default: '',
            },
            sitekey: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                disabled: false,
                grecaptcha_sitekey: this.sitekey,
                form: {
                    document: Number(this.articleid),
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    rgpd: '',
                    recaptcha_response: ''
                },
                errors: {
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    rgpd: '',
                    recaptcha_response: '',
                },
                success: false,
            }
        },
        mounted() {
            window.recaptchaCallback = this.recaptchaCallback;
        },
        methods: {
            recaptchaCallback(){
                this.$set(this.form, 'recaptcha_response', grecaptcha.getResponse())
                this.disabled = false
            },
            check () {
                if (this.$refs.formdocument.checkValidity()) {
                  return true
                } else {
                  this.$refs.formdocument.reportValidity()
                  return false
                }
            },
            resetErrors() {
                this.errors = {
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    rgpd: '',
                    recaptcha_response: '',
                }
            },
            getErrors(errors) {
                const data = {}
                const err = errors.response.data.data.params
                for(let error of err) {
                    data[error] = 'Ce champ est requis'
                }
                return data
            },
            toggleSlideover() {
                document.getElementById('slideover-container').classList.toggle('tw-invisible');
                document.getElementById('slideover-bg').classList.toggle('tw-opacity-0');
                document.getElementById('slideover-bg').classList.toggle('tw-opacity-100');
                document.getElementById('slideover').classList.toggle('tw-translate-y-full');
            },
            submitForm(e) {
                e.preventDefault();
                this.resetErrors()
                if (this.check()) {     
                    this.disabled = true
                    axios
                    .post("/api/v1/post-documents-subscriptions", this.form,{headers: {'content-type': 'application/json',}})
                    .then(response => {
                        this.success = true
                        if (response.data?.document_url) {
                            const downloadLink = document.createElement('a');
                            downloadLink.href = response.data.document_url;
                            downloadLink.target = '_blank';
                            downloadLink.click();
                            setTimeout(() => {
                                this.toggleSlideover();
                            }, 1000)
                        }

                        this.form = {
                            first_name: '',
                            last_name: '',
                            company: '',
                            email: '',
                            rgpd: '',
                        }
                        this.disabled = false
                        setTimeout(() => {
                            grecaptcha.reset();
                            this.success = false
                        }, 4000)
                    })
                    .catch((error) => {
                        console.log('error', error)
                        this.errors = Object.assign(this.errors, error.response.data)
                    })
                }
            }
        }
    })
}
